import { createContext } from 'react';
import { AsyncResult, ALWAYS_LOADING } from '../types/AsyncResult';
import { Experiment } from './types';

export type ExperimentContext = <T>(experiment: Experiment<T>) => AsyncResult<T>;

export const ExperimentContext = createContext<ExperimentContext>(() => ALWAYS_LOADING);
